/***********************
 * Group call licences table
 ************************/

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

//Translation
import { withTranslation } from "react-i18next"
import { stringSorter, numberSorter } from "utils/general"
import TableReporting from "components/Tables/TableReporting"

const GroupLicensesTable = props => {
  //Excel and pdf name
  const [title] = useState(props.t("Group call licenses"))
  //Table data state
  const [series, setSeries] = useState([])
  const [seriesTotal, setSeriesTotal] = useState([])
  //Table data state
  const [origSeries, setOrigSeries] = useState([])
  const [loading, setLoading] = useState(true)

  //Setting data state
  useEffect(() => {
    console.log("Data table group calls: " + JSON.stringify(props.data.list))
    if (props.data !== undefined) {
      if (props.data?.entries?.length > 0) {
        setSeries(props.data.entries)
        setOrigSeries(props.data.entries)

        // Set series that includes total entry for exports
        let withTotal = [...props.data.entries]
        let temp = {
          group: props.t("All"),
          hosts: props.data.hosts,
          guests: props.data.guests,
          hostAccounts: props.data.hostAccounts,
          guestClients: props.data.guestClients,
        }
        withTotal.unshift(temp)
        setSeriesTotal(withTotal)
        setLoading(false)
      }
    } else {
      setSeries([])
    }
  }, [props.data])

  // Export values
  const pdfHeading = [
    props.t("Group"),
    props.t("Group hosts"),
    props.t("Group hosts"),
    props.t("Group guests"),
    props.t("Group guests"),
  ]
  const pdfData = seriesTotal.map(elt => [
    elt.group,
    elt.hosts,
    elt.hostAccounts.join(", "),
    elt.guests,
    elt.guestClients.join(", "),
  ])

  const xlsxHeading = [pdfHeading]

  const xlsxData = seriesTotal.map(elt => [
    elt.group,
    elt.hosts,
    elt.hostAccounts.join(", "),
    elt.guests,
    elt.guestClients.join(", "),
  ])

  //Setting data state
  useEffect(() => {
    if (props.data !== undefined) {
      if (props.data?.entries?.length > 0) {
        setSeries(props.data.entries)

        // Set series that includes total entry for exports
        let withTotal = [...props.data.entries]
        let temp = {
          group: props.t("All"),
          hosts: props.data.hosts,
          guests: props.data.guests,
          hostAccounts: props.data.hostAccounts,
          guestClients: props.data.guestClients,
        }
        withTotal.unshift(temp)
        setSeriesTotal(withTotal)
      } else {
        setSeries([])
      }
    }
  }, [props.data])

  // Table structure
  const columns = [
    {
      dataIndex: "group",
      title: props.t("Group"),
      sorter: (a, b) => {
        return stringSorter(a, b, "group")
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "hosts",
      title: props.t("Group hosts"),
      sorter: (a, b, sortOrder) => {
        return numberSorter(a["hosts"], b["hosts"], sortOrder)
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "guests",
      title: props.t("Group guests"),
      sorter: (a, b, sortOrder) => {
        return numberSorter(a["guests"], b["guests"], sortOrder)
      },
      width: "140px",
      ellipsis: true,
    },
  ]

  return (
    <React.Fragment>
      <TableReporting
        origSeries={origSeries}
        title={title}
        columns={columns}
        seriesFiltered={series}
        xlsxHeading={xlsxHeading}
        xlsxData={xlsxData}
        pdfHeading={pdfHeading}
        pdfData={pdfData}
        loading={loading}
        noSearch={true}
      ></TableReporting>
    </React.Fragment>
  )
}

GroupLicensesTable.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
}

export default withTranslation()(GroupLicensesTable)
